import React, {
  memo,
  useMemo,
} from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import Form from '@active/react-ui/Form';
import EcheckItem from './components/EcheckItem';
import TextHr from '../../../../../../TextHr';

const Echeck = () => {
  const {
    entities: {
      envParams: {
        currencyCode,
      },
    },
    refundTotalAmount,
  } = useSelector(state => state.mainStateData);

  const {
    paymentMethodsConfig: {
      isSingleMode = true,
    } = {},
  } = useSelector(state => state.propsData);

  const {
    entities: paymentMethodsEntities,
  } = useSelector(state => state.paymentMethods);

  const savedEcheckAccounts = get(paymentMethodsEntities, [ 'paymentMethods', 'echeckInfo', 'savedAccounts' ], []);
  const isOnlyOneItem = useMemo(() => savedEcheckAccounts?.length === 1, [ savedEcheckAccounts ]);
  const isPrefillValue = useMemo(() => isSingleMode && isOnlyOneItem, [ isSingleMode, isOnlyOneItem ]);

  const initValues = useMemo(() => {
    if (isPrefillValue) {
      return { echeckAmount_0: refundTotalAmount };
    }
    return {};
  }, [ refundTotalAmount, isPrefillValue ]);

  if (isEmpty(savedEcheckAccounts)) {
    return null;
  }

  return <div className='multi-payment-echeck'>
    <Form
      enableReinitialize
      initialValues={initValues}
      customizeLayout>
      {
        savedEcheckAccounts.map((account, index) => <>
          {
            index > 0 && <TextHr />
          }
          <EcheckItem
            currencyCode={currencyCode}
            key={account.id}
            index={index}
            isPrefillValue={isPrefillValue}
            {...account}/>
        </>,
        )}
    </Form>
  </div>;
};

export default memo(Echeck);
